const Shimmer = () => {
  return (
    <div className="animate-pulse w-full h-28 sm:w-52 sm:h-56 bg-gray-300 mb-4 rounded-3xl"></div>
  );
};

const ShimmerForMenu = () => {
  return (
    <div className="animate-pulse w-full rounded-xl sm:rounded-2xl bg-gray-200 h-20 my-6"></div>
  );
};

export { Shimmer, ShimmerForMenu };
